import { Module } from "vuex";
import { RootState } from "../types";
import { AdminState } from "./types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const state: AdminState = {
  candidate: null,
};

const namespaced: boolean = true;

export const admin: Module<AdminState, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
